import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface ContentHeaderProps {
  title: string;
  toolbar?: ReactNode; // Optional toolbar content
  hasTable?: boolean;
}

const ContentHeader = ({ title }: ContentHeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "70px",
        width: "100%",
        position: "relative",
        bgcolor: theme.palette.secondary.main,
        borderBottom: 2,
        borderColor: "primary.main",
      }}
    >
      {/* Title always appears in the same place */}
      <Typography
        variant="h3"
        noWrap
        color={theme.palette.secondary.contrastText}
        sx={{
          position: "absolute",
          left: theme.spacing(2),
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default ContentHeader;
